import { render, staticRenderFns } from "./SidebarCompany.vue?vue&type=template&id=41af34ab&scoped=true&"
import script from "./SidebarCompany.vue?vue&type=script&lang=ts&"
export * from "./SidebarCompany.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCompany.vue?vue&type=style&index=0&id=41af34ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af34ab",
  null
  
)

export default component.exports